import { Component } from '@angular/core';
import {RouterLink} from '@angular/router';
import {LocalizationPipePipe} from '../../localization/control/localisation-pipe-pipe';
import {ObjectType} from '../../claims/entity/claim-item';

@Component({
  selector: 'app-home-page',
  imports: [
    RouterLink,
    LocalizationPipePipe
  ],
  templateUrl: './home-page.html',
  styleUrl: './home-page.scss'
})
export class HomePage {

  protected readonly ObjectType = ObjectType;
}
